import { Link } from 'react-router-dom';
import { formatPrice } from '../../../utils/formatPrice';
import { mediaUrl } from '../../../utils/mediaUrl';
import { ProductTags } from '../ProductTags';
import styles from './ProductCard.module.css';

export function ProductCard({ product, showOpenButton = false }) {
  const imageSrc = mediaUrl(product.image_url);
  const tags = product.tags || [];

  return (
    <article className={styles.card}>
      <Link to={`/product/${product.id}`} className={styles.imageLink}>
        <div className={styles.imageWrap}>
          {tags.length > 0 && (
            <ProductTags tags={tags} size="sm" className={styles.tags} />
          )}
          {imageSrc ? (
            <img src={imageSrc} alt={product.name} className={styles.image} loading="lazy" />
          ) : (
            <div className={styles.placeholder}>Нет фото</div>
          )}
        </div>
      </Link>

      <div className={styles.body}>
        <Link to={`/product/${product.id}`} className={styles.name}>
          {product.name}
        </Link>
        <p className={styles.price}>{formatPrice(product.price)}</p>
        {showOpenButton && (
          <Link to={`/product/${product.id}`} className={styles.openBtn}>
            Открыть
          </Link>
        )}
      </div>
    </article>
  );
}
